import classnames from 'classnames';
import React from 'react';
import loadSprite from './loadSprite';
import toastSuccessImg from './imgs/toast-success.png';
import './style.less';
const svgList = [
    'check',
    'check-circle',
    'check-circle-o',
    'cross',
    'cross-circle',
    'cross-circle-o',
    'left',
    'right',
    'down',
    'up',
    'loading',
    'newloading',
    'search',
    'ellipsis',
    'ellipsis-circle',
    'exclamation-circle',
    'info-circle',
    'question-circle',
    'voice',
    'plus',
    'minus',
    'dislike',
    'fail',
    'success',
    'clear',
    'pcloading',
    'toast_fail',
    'icon-app',
    'checbox-circle-checked'
];
const pngMap = {
    'toast-success': toastSuccessImg,
};
class Icon extends React.Component {
    componentDidMount() {
        loadSprite();
    }
    render() {
        const { type, className, color, size, viewBox, ...restProps } = this.props;
        const cls = classnames(className, 'im-icon', `im-icon-${type}`, `im-icon-${size}`);
        if (svgList.includes(type)) {
            return (createElement("svg", Object.assign({ className: cls, viewBox: viewBox }, restProps),
                createElement("use", { xlinkHref: `#${type}`, fill: color })));
        }
        return createElement("img", Object.assign({ src: pngMap[type], className: cls }, restProps));
    }
}
Icon.defaultProps = {
    size: 'md',
};
export default Icon;
